// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3uXgQ","Profile":"NavigationItem_Profile__10EHO","active":"NavigationItem_active__1203k"};